module.exports = __webpack_public_path__ + "static/media/Rukmini_Nazre.a66bccf4.jpg";